module.exports = __webpack_public_path__ + "media/images/logo-4b2ce4fb2650a6c754530782389b3e8e.svg";